import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_PERIOD,
  COLUMN_DUE_DATE,
  COLUMN_EXPENSE_TYPE,
  COLUMN_BUSINESS_PARTNER,
  COLUMN_BUSINESS_PARTNER_ID,
  COLUMN_AFFILIATES,
  COLUMN_AFFILIATE_IDS,
  COLUMN_BUSINESS_PARTNER_COUNTRY,
  COLUMN_CUSTOMER_COMPANY,
  COLUMN_APPLICATION,
  COLUMN_ROAS_D7,
  COLUMN_CPI,
  COLUMN_CVR,
  COLUMN_REGS,
  COLUMN_SPENDING,
  COLUMN_TOTAL_INVOICES_AMOUNT,
  COLUMN_AMOUNT_GAP,
  COLUMN_UA_REJECTED_INSTALLS,
  COLUMN_RE_REJECTED_INSTALLS,
  COLUMN_TOTAL_REJECTED_INSTALLS,
  COLUMN_STATUS,
  COLUMN_OWNER,
  COLUMN_HISTORY_APPROVERS,
  COLUMN_IMPORTANCE,
  COLUMN_IO_BUDGET_ROR_FR,
  COLUMN_CREATED_DATE,
  COLUMN_LAST_UPDATED_DATE,
  COLUMN_PAYMENT_DATE,
  COLUMN_IO_DOCUMENT_PERIODS,
} from 'scenes/FinancialResults/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_PERIOD,
    COLUMN_DUE_DATE,
    COLUMN_BUSINESS_PARTNER,
    COLUMN_BUSINESS_PARTNER_ID,
    COLUMN_AFFILIATES,
    COLUMN_AFFILIATE_IDS,
    COLUMN_BUSINESS_PARTNER_COUNTRY,
    COLUMN_STATUS,
    COLUMN_IMPORTANCE,
    COLUMN_CUSTOMER_COMPANY,
    COLUMN_EXPENSE_TYPE,
    COLUMN_APPLICATION,
    COLUMN_ROAS_D7,
    COLUMN_CPI,
    COLUMN_CVR,
    COLUMN_REGS,
    COLUMN_SPENDING,
    COLUMN_TOTAL_INVOICES_AMOUNT,
    COLUMN_AMOUNT_GAP,
    COLUMN_UA_REJECTED_INSTALLS,
    COLUMN_RE_REJECTED_INSTALLS,
    COLUMN_TOTAL_REJECTED_INSTALLS,
    COLUMN_HISTORY_APPROVERS,
    COLUMN_PAYMENT_DATE,
    COLUMN_IO_DOCUMENT_PERIODS,
    COLUMN_IO_BUDGET_ROR_FR,
    COLUMN_LAST_UPDATED_DATE,
    COLUMN_OWNER,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
